// 合作代理商
import React from 'react'
import styles from './CooperationAgents.module.scss'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'
import useCooperationAgents from '@/hooks/useCooperationAgents'

const CooperationAgents: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  // logo 列表改为从海马配置接口读取，接口为空/异常时回退到硬编码 cooperationAgents
  const { agents } = useCooperationAgents()

  return (
    <section className={styles.section}>
      <div className={styles.title}>{t('cooperationAgents', "合作代理商")}</div>
      <div className={styles.gridContainer}>
        {agents.map((agent) => (
             <div className={styles.placeholderLogo} key={agent.id}>
              <img src={agent.logo} alt={`Agent ${agent.id}`} />
             </div>
        ))}
      </div>
    </section>
  )
}

const CooperationAgentsWithTranslator = withTranslator(CooperationAgents)
export default CooperationAgentsWithTranslator
